<template>
   <main class="container mx-auto flex flex-col items-start gap-20 px-4 py-10 pb-12 md:flex-row md:gap-6 md:px-0 md:pb-28">

      <div class="w-full md:max-w-[428px]">
        <div class="text-small-text-regular text-black-40 pb-2">
            {{ onOfficeLabels['Id']['label'] }}: {{ property['elements']['Id'] }}
        </div>
        <section class="w-full rounded-3xl py-4 shadow md:max-w-[428px] md:py-8">
            <figure class="flex flex-row flex-wrap items-start gap-[10px] px-4 md:px-9">
                <a
                    class="flex items-center justify-center gap-2 rounded-full bg-green-10 px-3 py-2 text-black-78 shadow"
                    v-if="property.elements.status2 == 'vorbereitung'"
                >
                <v-icon icon="hourglass" class="h-[14px] w-[14px]"></v-icon>
                <label class="text-small-text-medium">V pregledu{{ completedPayment != null ? ' (Plačano)' : '' }}</label>
                </a>
                <a
                class="flex items-center justify-center gap-2 rounded-full bg-green px-3 py-2 text-white shadow"
                v-if="property.elements.status2 == 'status2obj_aktiv'"
                >
                <v-icon icon="circle-check" class="h-[14px] w-[14px]"></v-icon>
                <label class="text-small-text-medium">Objavljeno</label>
                </a>
                <a
                    class="flex items-center justify-center gap-2 rounded-full bg-white px-3 py-2 text-black-78 shadow"
                    v-if="property.elements.status2 == ''"
                >
                <v-icon icon="fire" class="h-[14px] w-[14px]"></v-icon>
                <label class="text-small-text-medium">Top oglas</label>
                </a>
                <a

                class="flex items-center justify-center gap-2 rounded-full bg-gray-E5 px-3 py-2 text-black-78 shadow"
                v-if="property.elements.status2 == 'status2obj_inaktiv'"
                >
                <v-icon icon="pause" class="h-[14px] w-[14px]"></v-icon>
                <label class="text-small-text-medium">Deaktivirano</label>
                </a>
                <a
                class="flex items-center justify-center gap-2 rounded-full bg-salmon px-3 py-2 text-white shadow"
                v-if="property.elements.status2 == 'ind_Schl_3269'"
                >
                <v-icon icon="x-circle" class="h-[14px] w-[14px]"></v-icon>
                <label class="text-small-text-medium">Odloženo</label>
                </a>
                <a
                class="flex items-center justify-center gap-2 rounded-full bg-salmon px-3 py-2 text-white shadow"
                v-if="inProgressPayment != null"
                >
                    <v-icon icon="payments" class="h-[14px] w-[14px]"></v-icon>
                    <label class="text-small-text-medium">Plačilo v teku</label>
                </a>
            </figure>
            <figure
                class="mb-8 mt-4 px-4 text-heading-4-bold text-black-78 md:px-9 md:text-heading-2-mobile">
                {{ property.elements.objekttitel }}
            </figure>
            <figure class="no-scrollbar flex gap-[10px] overflow-x-scroll px-4 md:px-9">

                <div
                    v-for="(image, index) in property.mapped_images"
                    v-bind:key="'estate-image-' + index"
                    class="image flex min-h-[96px] min-w-[144px] flex-1 items-center justify-center overflow-hidden rounded-2xl">
                <img
                    :src="image.elements[0].url"
                    alt=""
                    >
                </div>
            </figure>
            <figure class="my-8 grid grid-cols-2 gap-x-4 gap-y-8 px-4 md:px-9">
                <section class="flex flex-col gap-[6px]">
                <figcaption class="flex items-center gap-x-2">
                    <v-icon icon="house-dots" size="5"></v-icon>
                    <span class="text-icon-text-medium">
                        {{ this.$globalFunctions.onOfficeValueResolver(onOfficeLabels, 'objektart', property.elements.objektart) }}
                    </span>
                </figcaption>
                <label class="text-small-text-regular text-black-40">
                        {{ this.$globalFunctions.onOfficeLabelResolver(onOfficeLabels, 'objektart') }}
                </label>
                </section>
                <section class="flex flex-col gap-[6px]">
                <figcaption class="flex items-center gap-x-2">
                    <v-icon icon="house-work" size="5"></v-icon>
                    <span class="text-icon-text-medium">
                        {{ this.$globalFunctions.onOfficeValueResolver(onOfficeLabels, 'objekttyp', property.elements.objekttyp) }}
                    </span>
                </figcaption>
                <label class="text-small-text-regular text-black-40">
                    {{ this.$globalFunctions.onOfficeLabelResolver(onOfficeLabels, 'objekttyp') }}
                </label>
                </section>
                <section class="flex flex-col gap-[6px]">
                <figcaption class="flex items-center gap-x-2">
                    <v-icon icon="square-size" size="5"></v-icon>
                    <span class="text-icon-text-medium" v-if="property.elements.objektart != 'grundstueck'">
                        {{ property.elements.wohnflaeche }} m<sup>2</sup></span>
                    <span class="text-icon-text-medium" v-else>
                        {{ property.elements.grundstuecksflaeche }} m<sup>2</sup></span>
                </figcaption>
                <label class="text-small-text-regular text-black-40" v-if="property.elements.objektart != 'grundstueck'">
                    {{ this.$globalFunctions.onOfficeLabelResolver(onOfficeLabels, 'wohnflaeche') }}
                </label>
                <label class="text-small-text-regular text-black-40" v-else>
                    {{ this.$globalFunctions.onOfficeLabelResolver(onOfficeLabels, 'grundstuecksflaeche') }}
                </label>
                </section>
                <section class="flex flex-col gap-[6px]" v-if="property.elements.objektart != 'grundstueck'">
                <figcaption class="flex items-center gap-x-2">
                    <v-icon icon="door" size="5"></v-icon>
                    <span class="text-icon-text-medium">
                        {{ this.$globalFunctions.parseRoomCount(property.elements.anzahl_zimmer) }}- sobno
                    </span>
                </figcaption>
                <label class="text-small-text-regular text-black-40">
                        {{ this.$globalFunctions.onOfficeLabelResolver(onOfficeLabels, 'anzahl_zimmer') }}
                </label>
                </section>
            </figure>
            <figure class="px-4 text-heading-2-mobile text-green-49 md:px-9 md:text-heading-2-desktop">

                <template v-if="property.elements.vermarktungsart == 'miete'">
                    <span class="text-green">{{ property.elements.kaltmiete }}</span> € / mesec
                </template>
                <template v-else>
                    <span class="text-green">{{ this.$globalFunctions.formatPrice(property.elements.kaufpreis) }}</span> €
                </template>
            </figure>
            <hr class="my-8">
            <figure class="flex flex-row flex-wrap items-center justify-between gap-4 px-4 md:px-9">
                <!--<v-lightbox
                    :head-class="'border-b'"
                    :content-class="'px-4 md:px-8'"
                    :foot-class="'justify-center border-t'"
                    :is-authenticated="true"
                    v-if="inProgressPayment == null && property.elements.status2 == 'status2obj_aktiv' && property.elements.status == '1'"
                >
                <template v-slot:trigger>
                    <a class="button">
                        <v-icon icon="edit"></v-icon>
                        <label>Uredite oglas</label>
                    </a>
                </template>
                <template v-slot:head>
                    <v-icon icon="preview" size="4" class="mr-2.5"></v-icon>
                    <label>Uredite oglas</label>
                </template>
                <template v-slot:content>
                    <figure class="mx-auto flex max-w-md items-center justify-center">
                        <div class="text-icon-text-medium text-black-78">
                            Kaj se zgodi, če boste urejali objavljen oglas?
                        </div>
                    </figure>
                    <figure class="mx-auto mb-11 mt-11 flex max-w-md flex-col gap-10">
                        <section class="flex items-center gap-4">
                            <div class="flex h-10 w-10 items-center justify-center rounded-full bg-green">
                            <v-icon class="text-white" icon="hourglass"></v-icon>
                            </div>
                            <div class="flex-1 text-body-regular text-black-78">
                            Z urejanjem trenutno objavljenega oglasa bo potrebno podatke oglasa še
                            enkrat pregledati.
                            </div>
                        </section>
                        <section class="flex items-center gap-4">
                            <div class="flex h-10 w-10 items-center justify-center rounded-full bg-green">
                            <v-icon class="text-white" icon="nest-clock-farsight-analog"></v-icon>
                            </div>
                            <div class="flex-1 text-body-regular text-black-78">
                            Pregled traja največ 24 ur.
                            </div>
                        </section>
                        <section class="flex items-center gap-4">
                            <div class="flex h-10 w-10 items-center justify-center rounded-full bg-green">
                            <v-icon class="text-white" icon="update"></v-icon>
                            </div>
                            <div class="flex-1 text-body-regular text-black-78">
                            Vaš zakupljen paket trajanja oglasa se med pregledom
                            <span class="text-body-bold text-green">
                                ne zamrzne
                            </span>
                            in teče naprej.
                            </div>
                        </section>
                        <section class="flex items-center gap-4">
                            <div class="flex h-10 w-10 items-center justify-center rounded-full bg-green">
                            <v-icon class="text-white" icon="mark-email-unread"></v-icon>
                            </div>
                            <div class="flex-1 text-body-regular text-black-78">
                            Po eletronski pošti vas bomo obvestili, ko bo oglas ponovno objavljen.
                            </div>
                        </section>
                    </figure>
                </template>
                <template v-slot:foot>
                    <a class="button button--form" :href="urls.editProperty">
                        <label>Želim urediti oglas</label>
                        <v-icon icon="arrow-right"></v-icon>
                    </a>
                </template>
                </v-lightbox>-->
                <a class="button" :href="urls.listing">
                <v-icon icon="preview"></v-icon>
                <label>Predogled oglasa</label>
                </a>
                <!-- Only show this button when status2 is rejected and inactive -->
                <a class="button" :href="urls.editProperty" v-if="inProgressPayment == null && property.elements.status2 == 'ind_Schl_3269' && property.elements.status == '2'">
                <v-icon icon="preview"></v-icon>
                <label>Popravite oglas</label>
                </a>
                <a class="button" :href="urls.editProperty" v-if="inProgressPayment == null && property.elements.status2 != 'ind_Schl_3269' && property.elements.status != '1'">
                    <v-icon icon="preview"></v-icon>
                    <label>Uredite oglas</label>
                </a>
            </figure>
        </section>
      </div>

      <section class="flex flex-grow flex-col gap-20">

         <figure class="flex flex-col gap-4">
            <div class="text-heading-3-desktop text-black-78">Status oglasa</div>

            <v-session-message :session="session"/>

            <!-- Listing is in review -->
            <div class="w-full md:rounded-3xl md:p-11 md:shadow" v-if="inProgressPayment == null && property.elements.status == '2' && property.elements.status2 == 'vorbereitung'">
               <section>
                  <div class="flex flex-1 flex-col gap-3">
                     <div class="flex items-center gap-2 text-black-78">
                        <v-icon icon="clock" class="h-[18px] w-[18px]"></v-icon>
                        <label class="text-icon-text-medium">{{ completedPayment != null ? 'Plačilo uspešno, oglas je v pregledu' : 'Ta oglas je v pregledu' }}</label>
                     </div>
                     <div
                        class="relative flex h-[6px] w-full max-w-[400px] overflow-hidden rounded-full bg-gray-border">
                        <div class="h-[6px] w-full bg-gray-border"></div>
                     </div>
                  </div>
               </section>
               <hr class="my-8">

               <section class="flex flex-col justify-between gap-y-6 md:flex-row" v-if="todo">
                  <div class="flex flex-1 flex-col gap-3">
                     <div class="flex items-center gap-2 text-black-40">
                        <v-icon icon="fire" class="h-[18px] w-[18px]"></v-icon>
                        <p class="text-body-regular">Oglas ni izpostavljen kot “top oglas”
                        </p>
                     </div>
                     <div
                        class="relative flex h-[6px] w-full max-w-[400px] overflow-hidden rounded-full bg-gray-border">
                        <div class="h-[6px] w-full bg-gray-border"></div>
                     </div>
                  </div>
                  <a class="button button--white button--disabled">
                     <v-icon icon="fire"></v-icon>
                     <label>Izpostavite oglas</label>
                  </a>
               </section>
               <hr class="my-8" v-if="todo">
               <section v-if="property.elements.ind_2158_Feld_ObjIndividualCategoryFields92">
                  <p class="mb-4 text-body-regular text-black-40">
                     Za ta oglas ste zakupili paket trajanja za 90 dni. Ta oglas vam bo potekel dne {{ this.$globalFunctions.formatDate(property.elements.ind_2162_Feld_ObjIndividualCategoryFields94) }}
                  </p>
                  <p class="text-body-regular text-black-40">
                     Po poteku 90 dni se bo oglas deaktiviral. To pomeni, da bo oglas še vedno ostal v
                     naši bazi, vendar ne bo viden iskalcem. Oglas lahko ponovno aktivirate z zakupom
                     novega aktivnega obdobja (30, 60 ali 90 dni).
                  </p>
               </section>
            </div>

            <!-- Listing is posted -->
            <div class="w-full md:rounded-3xl md:p-11 md:shadow" v-if="inProgressPayment == null && property.elements.status == '1'">
               <section class="flex flex-col justify-between gap-y-6 md:flex-row">
                  <div class="flex flex-1 flex-col gap-3">
                     <div class="flex items-center gap-2 text-black-78">
                        <v-icon icon="clock" class="h-[18px] w-[18px]"></v-icon>
                        <label class="text-icon-text-medium">
                           Ta oglas bo objavljen še toliko dni: {{ property.advertising_days_left }}
                        </label>
                     </div>
                     <div class="relative flex h-[6px] w-full max-w-[400px] overflow-hidden rounded-full bg-gray-border">
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>

                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>

                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>

                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full rounded-r-full bg-green-49"></div>
                        <!-- <div class="h-[6px] w-full bg-green-49"></div> -->
                        <!-- <div class="h-[6px] w-full bg-green-49"></div> -->

                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->

                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>

                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>

                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>

                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>

                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                     </div>
                  </div>
                  <div>
                     <v-lightbox
                        :head-class="'border-b'"
                        :content-class="'px-4 md:px-8'"
                        :foot-class="'justify-center border-t'"
                        :is-authenticated="true"
                        :show="showListingDeactivationModal"
                        @close="showListingDeactivationModal = false"
                     >
                        <template v-slot:trigger>
                           <a class="button" @click="showListingDeactivationModal = true">
                              <v-icon icon="pause"></v-icon>
                              <label>Deaktivirajte oglas</label>
                           </a>
                        </template>
                        <template v-slot:head>
                           <v-icon icon="pause" size="4" class="mr-2.5"></v-icon>
                           <label>Deaktivirajte oglas</label>
                        </template>
                        <template v-slot:content>
                           <template v-if="steps.deactivate.first">
                              <figure class="mx-auto flex max-w-md items-center justify-center">
                                 <div class="text-icon-text-medium text-black-78">
                                    Kaj se zgodi, če deaktivirate oglas?
                                 </div>
                              </figure>
                              <figure class="mx-auto mb-11 mt-11 flex max-w-md flex-col gap-10">
                                 <section class="flex items-center gap-4">
                                    <div
                                       class="flex h-10 w-10 items-center justify-center rounded-full bg-green">
                                       <v-icon class="text-white" icon="close"></v-icon>
                                    </div>
                                    <div class="flex-1 text-body-regular text-black-78">
                                       Z deaktivacijo oglasa boste prekinili paket trajanja oglasa. S
                                       tem boste izgubili
                                       <span class="text-bodu-bold text-green">
                                        {{ property.advertising_days_left }}
                                       </span>
                                       dni oglaševanja.
                                    </div>
                                 </section>
                                 <section class="flex items-center gap-4">
                                    <div
                                       class="flex h-10 w-10 items-center justify-center rounded-full bg-green">
                                       <v-icon class="text-white" icon="visibility-off"></v-icon>
                                    </div>
                                    <div class="flex-1 text-body-regular text-black-78">
                                       Oglas ne bo več viden ostalim iskalcem nepremičnin na portalu
                                       N24.
                                    </div>
                                 </section>
                                 <section class="flex items-center gap-4">
                                    <div
                                       class="flex h-10 w-10 items-center justify-center rounded-full bg-green">
                                       <v-icon class="text-white" icon="resume"></v-icon>
                                    </div>
                                    <div class="flex-1 text-body-regular text-black-78">
                                       Oglas bo ostal med vašimi oglasi, kjer ga boste lahko s ponovim
                                       zakupom paketa trajanja oglasa še enkrat javno objavili.
                                    </div>
                                 </section>
                              </figure>
                           </template>
                           <template v-if="steps.deactivate.second">
                              <figure class="mx-auto flex max-w-md items-center justify-center">
                                 <div class="text-icon-text-medium text-black-78">
                                    S kakšnim razlogom želite deaktivirati oglas?
                                 </div>
                              </figure>
                              <figure class="mx-auto my-11 flex max-w-md items-center justify-center">
                                 <div class="w-full">
                                    <ul class="flex flex-col gap-[10px]">
                                       <li class="w-full" v-if="property.elements.vermarktungsart == 'kauf'">
                                          <div class="radio group flex items-center">
                                             <input id="nepremicninaJeProdana" type="radio"
                                                value="sold"
                                                name="sKaksnimRazlogomZeliteDeaktiviratiOglas"
                                                v-model="postData.deactivate.disable_reason"
                                                class="hidden" />
                                             <label for="nepremicninaJeProdana"
                                                class="w-full text-body-medium-button">
                                                <div class="label">Nepremičnina je prodana</div>
                                                <div class="icon">
                                                   <v-icon icon="radio-unchecked"
                                                      class="unchecked"></v-icon>
                                                   <v-icon icon="radio-checked"
                                                      class="checked"></v-icon>
                                                </div>
                                             </label>
                                          </div>
                                       </li>
                                       <li class="w-full" v-if="property.elements.vermarktungsart == 'miete'">
                                          <div class="radio group flex items-center">
                                             <input id="nepremicninaJeOddana" type="radio"
                                                value="rented"
                                                name="sKaksnimRazlogomZeliteDeaktiviratiOglas"
                                                v-model="postData.deactivate.disable_reason"
                                                class="hidden" />
                                             <label for="nepremicninaJeOddana"
                                                class="w-full text-body-medium-button">
                                                <div class="label">Nepremičnina je oddana</div>
                                                <div class="icon">
                                                   <v-icon icon="radio-unchecked"
                                                      class="unchecked"></v-icon>
                                                   <v-icon icon="radio-checked"
                                                      class="checked"></v-icon>
                                                </div>
                                             </label>
                                          </div>
                                       </li>
                                       <li class="w-full">
                                          <div class="radio group flex items-center">
                                             <input id="nepremicninaJeDrugo" type="radio"
                                                value="other"
                                                name="sKaksnimRazlogomZeliteDeaktiviratiOglas"
                                                v-model="postData.deactivate.disable_reason"
                                                class="hidden" />
                                             <label for="nepremicninaJeDrugo"
                                                class="w-full text-body-medium-button">
                                                <div class="label">Drugo</div>
                                                <div class="icon">
                                                   <v-icon icon="radio-unchecked"
                                                      class="unchecked"></v-icon>
                                                   <v-icon icon="radio-checked"
                                                      class="checked"></v-icon>
                                                </div>
                                             </label>
                                          </div>
                                       </li>
                                       <template v-if="this.$globalFunctions.parseApiErrors(postData.errors, 'disable_reason')">
                                          <div class="mb-4 w-full pt-0 text-small-text-regular text-salmon"
                                          >
                                             {{ this.$globalFunctions.parseApiErrors(postData.errors, 'disable_reason') }}
                                          </div>
                                       </template>
                                       <hr class="my-11">
                                       <li class="w-full" v-if="property.elements.vermarktungsart == 'miete' && (postData.deactivate.disable_reason != null && postData.deactivate.disable_reason != 'other')">
                                          <div class="input group relative flex flex-col gap-[10px]">
                                             <label for="addPrice"
                                                class="w-full text-body-medium-button">
                                                <div class="label flex flex-col gap-[10px]">
                                                   <div class="flex items-center gap-3">
                                                      <v-icon icon="euro" size="4"></v-icon>
                                                      <span>
                                                         Kakšna je končna mesečna najemnina za nepremičnino?
                                                      </span>
                                                   </div>
                                                </div>
                                             </label>
                                             <input
                                                id="addPrice"
                                                type="text"
                                                name="preis"
                                                placeholder="Mesečna najemnina"
                                                v-model="postData.deactivate.final_price"
                                             />
                                             <span
                                                class="absolute bottom-[18px] right-6 text-body-medium-button"
                                                :class="postData.deactivate.final_price ? 'text-black-78' : 'text-black-40'">
                                                € / mesec
                                             </span>
                                          </div>
                                       </li>
                                       <li class="w-full" v-if="property.elements.vermarktungsart == 'kauf' && (postData.deactivate.disable_reason != null && postData.deactivate.disable_reason != 'other')">
                                          <div class="input group relative flex flex-col gap-[10px]">
                                             <label for="addPrice"
                                                class="w-full text-body-medium-button">
                                                <div class="label flex flex-col gap-[10px]">
                                                   <div class="flex items-center gap-3">
                                                      <v-icon icon="euro" size="4"></v-icon>
                                                      <span>
                                                         Kakšna je končna prodajna cena te nepremičnine ?
                                                      </span>
                                                   </div>
                                                </div>
                                             </label>
                                             <input
                                                id="addPrice"
                                                type="text"
                                                name="preis"
                                                placeholder="Končna cena"
                                                v-model="postData.deactivate.final_price"
                                             />
                                             <span
                                                class="absolute bottom-[18px] right-6 text-body-medium-button"
                                                :class="postData.deactivate.final_price ? 'text-black-78' : 'text-black-40'">
                                                €
                                             </span>
                                          </div>
                                       </li>
                                       <template v-if="this.$globalFunctions.parseApiErrors(postData.errors, 'final_price')">
                                          <div class="mb-4 w-full pt-0 text-small-text-regular text-salmon"
                                          >
                                             {{ this.$globalFunctions.parseApiErrors(postData.errors, 'final_price') }}
                                          </div>
                                       </template>
                                    </ul>
                                </div>
                              </figure>
                           </template>
                           <template v-if="steps.deactivate.third">
                              <figure
                                 class="mx-auto my-11 flex max-w-md items-center justify-center gap-2 md:my-32">
                                 <div class="text-green">
                                    <v-icon icon="pause"></v-icon>
                                 </div>
                                 <div class="text-icon-text-medium text-green">
                                    Uspešno ste deaktivirali oglas
                                 </div>
                              </figure>
                           </template>
                        </template>
                        <template v-slot:foot>
                           <template v-if="steps.deactivate.first">
                              <a class="button button--form" @click="steps.deactivate.first = false, steps.deactivate.second = true, steps.deactivate.third = false">
                                 <label>Nadaljujte</label>
                                 <v-icon icon="arrow-right"></v-icon>
                              </a>
                           </template>
                           <template v-if="steps.deactivate.second">
                              <a class="button button--form" @click="submitListingDeactivationRequest()">
                                 <label>Želim deaktivirati oglas</label>
                                 <v-icon icon="pause"></v-icon>
                              </a>
                           </template>
                           <template v-if="steps.deactivate.third">
                              <a class="button button--form" @click="steps.deactivate.first = true, steps.deactivate.second = false, steps.deactivate.third = false, showListingDeactivationModal = false">
                                 <label>Zapri</label>
                                 <v-icon icon="close"></v-icon>
                              </a>
                           </template>
                        </template>
                     </v-lightbox>
                  </div>
               </section>
               <hr class="my-8">
               <section class="flex flex-col justify-between gap-y-6 md:flex-row" v-if="todo">
                  <div class="flex flex-1 flex-col gap-3">
                     <div class="flex items-center gap-2 text-black-78">
                        <v-icon icon="fire" class="h-[18px] w-[18px]"></v-icon>
                        <label class="text-icon-text-medium">
                           Izpostavljenost kot “top oglas” še toliko dni: 38
                        </label>
                     </div>
                     <div class="relative flex h-[6px] w-full max-w-[400px] overflow-hidden rounded-full bg-gray-border">
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>

                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>

                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>

                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full bg-green-49"></div>
                        <div class="h-[6px] w-full rounded-r-full bg-green-49"></div>
                        <!-- <div class="h-[6px] w-full bg-green-49"></div> -->
                        <!-- <div class="h-[6px] w-full bg-green-49"></div> -->

                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->
                        <!-- <div class="h-[6px] w-full bg-gray-border"></div> -->

                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>

                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>

                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>

                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>

                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                        <div class="h-[6px] w-full bg-gray-border"></div>
                     </div>
                  </div>
               </section>
               <hr class="my-8" v-if="todo">
               <section>
                  <p class="mb-4 text-body-regular text-black-40">
                     Za ta oglas ste zakupili paket trajanja za 90 dni. Ta oglas vam bo potekel dne {{ this.$globalFunctions.formatDate(property.elements.ind_2162_Feld_ObjIndividualCategoryFields94) }}
                  </p>
                  <p class="text-body-regular text-black-40">
                     Po poteku 90 dni se bo oglas deaktiviral. To pomeni, da bo oglas še vedno ostal v
                     naši bazi, vendar ne bo viden iskalcem. Oglas lahko ponovno aktivirate z zakupom
                     novega aktivnega obdobja (30, 60 ali 90 dni).
                  </p>
               </section>
            </div>

            <!-- Listing deactivated -->
            <div class="w-full md:rounded-3xl md:p-11 md:shadow" v-if="inProgressPayment == null && property.elements.status == '2' && property.elements.status2 == 'status2obj_inaktiv'">
               <section class="flex flex-col justify-between gap-y-6 md:flex-row">
                  <div class="flex flex-1 flex-col gap-3">
                     <div class="flex items-center gap-2 text-black-78">
                        <v-icon icon="clock" class="h-[18px] w-[18px]"></v-icon>
                        <label class="text-icon-text-medium">Oglas je deaktiviran</label>
                     </div>
                     <div
                        class="relative flex h-[6px] w-full max-w-[400px] overflow-hidden rounded-full bg-gray-border">
                        <div class="h-[6px] w-full bg-gray-border"></div>
                     </div>
                  </div>
                  <div class="flex flex-col items-center gap-x-[10px] gap-y-6 md:flex-row">
                     <a class="button" :href="urls.activateProperty" v-if="inProgressPayment == null">
                        <v-icon icon="play"></v-icon>
                        <label>Objavite oglas</label>
                     </a>
                     <v-lightbox
                        :head-class="'border-b'"
                        :content-class="'px-4 md:px-8'"
                        :foot-class="'justify-center border-t'"
                        :is-authenticated="true"
                        :show="showListingRemovalModal"
                        @close="showListingRemovalModal = false"
                    >
                        <template v-slot:trigger>
                           <a class="button button--white" @click="showListingRemovalModal = true">
                              <v-icon icon="trash"></v-icon>
                              <label>Izbrišite oglas</label>
                           </a>
                        </template>
                        <template v-slot:head>
                           <v-icon icon="trash" size="4" class="mr-2.5"></v-icon>
                           <label>Izbrišite oglas</label>
                        </template>
                        <template v-slot:content>
                           <template v-if="steps.delete.first">
                              <figure class="mx-auto flex max-w-md items-center justify-center">
                                 <div class="text-icon-text-medium text-black-78">
                                    Kaj se zgodi, če boste za vedno izbrisali oglas?
                                 </div>
                              </figure>
                              <figure class="mx-auto my-11 flex max-w-md flex-col gap-10">
                                 <section class="flex items-center gap-4">
                                    <div
                                       class="flex h-10 w-10 items-center justify-center rounded-full bg-salmon">
                                       <v-icon class="text-white" icon="visibility-off"></v-icon>
                                    </div>
                                    <div class="flex-1 text-body-regular text-black-78">
                                       Oglas ne bo več viden vam in ostalim iskalcem nepremičnin na
                                       portalu N24.
                                    </div>
                                 </section>
                                 <section class="flex items-center gap-4">
                                    <div
                                       class="flex h-10 w-10 items-center justify-center rounded-full bg-salmon">
                                       <v-icon class="text-white" icon="contract-delete"></v-icon>
                                    </div>
                                    <div class="flex-1 text-body-regular text-black-78">
                                       Z izbrisom oglasa se izbrišejo tudi vsi podatki o nepremičnini.
                                    </div>
                                 </section>
                                 <section class="flex items-center gap-4">
                                    <div
                                       class="flex h-10 w-10 items-center justify-center rounded-full bg-salmon">
                                       <v-icon class="text-white" icon="delete-history"></v-icon>
                                    </div>
                                    <div class="flex-1 text-body-regular text-black-78">
                                       Oglasa ne bo mogoče več ponovno aktivirati, saj ga boste
                                       izbrisali
                                       iz vaših oglasov
                                    </div>
                                 </section>
                              </figure>
                           </template>
                           <template v-if="steps.delete.second">
                              <figure class="mx-auto flex max-w-md items-center justify-center">
                                 <div class="text-icon-text-medium text-black-78">
                                    S kakšnim razlogom želite izbrisati oglas?
                                 </div>
                              </figure>
                              <figure class="mx-auto my-11 flex max-w-md items-center justify-center">
                                 <div class="w-full">
                                    <ul class="flex flex-col gap-[10px]">
                                       <li class="w-full" v-if="property.elements.vermarktungsart == 'kauf'">
                                          <div class="radio group flex items-center">
                                             <input id="nepremicninaJeProdana" type="radio"
                                                value="sold"
                                                name="sKaksnimRazlogomZeliteDeaktiviratiOglas"
                                                v-model="postData.delete.removal_reason"
                                                class="hidden" />
                                             <label for="nepremicninaJeProdana"
                                                class="w-full text-body-medium-button">
                                                <div class="label">Nepremičnina je prodana</div>
                                                <div class="icon">
                                                   <v-icon icon="radio-unchecked"
                                                      class="unchecked"></v-icon>
                                                   <v-icon icon="radio-checked"
                                                      class="checked"></v-icon>
                                                </div>
                                             </label>
                                          </div>
                                       </li>
                                       <li class="w-full" v-if="property.elements.vermarktungsart == 'miete'">
                                          <div class="radio group flex items-center">
                                             <input id="nepremicninaJeOddana" type="radio"
                                                value="rented"
                                                name="sKaksnimRazlogomZeliteDeaktiviratiOglas"
                                                v-model="postData.delete.removal_reason"
                                                class="hidden" />
                                             <label for="nepremicninaJeOddana"
                                                class="w-full text-body-medium-button">
                                                <div class="label">Nepremičnina je oddana</div>
                                                <div class="icon">
                                                   <v-icon icon="radio-unchecked"
                                                      class="unchecked"></v-icon>
                                                   <v-icon icon="radio-checked"
                                                      class="checked"></v-icon>
                                                </div>
                                             </label>
                                          </div>
                                       </li>
                                       <li class="w-full">
                                          <div class="radio group flex items-center">
                                             <input id="nepremicninaJeDrugo" type="radio"
                                                value="other"
                                                v-model="postData.delete.removal_reason"
                                                name="sKaksnimRazlogomZeliteDeaktiviratiOglas"
                                                class="hidden" />
                                             <label for="nepremicninaJeDrugo"
                                                class="w-full text-body-medium-button">
                                                <div class="label">Drugo</div>
                                                <div class="icon">
                                                   <v-icon icon="radio-unchecked"
                                                      class="unchecked"></v-icon>
                                                   <v-icon icon="radio-checked"
                                                      class="checked"></v-icon>
                                                </div>
                                             </label>
                                          </div>
                                       </li>
                                       <template v-if="this.$globalFunctions.parseApiErrors(postData.errors, 'removal_reason')">
                                          <div class="mb-4 w-full pt-0 text-small-text-regular text-salmon"
                                          >
                                             {{ this.$globalFunctions.parseApiErrors(postData.errors, 'removal_reason') }}
                                          </div>
                                       </template>
                                       <hr class="my-11">
                                       <li class="w-full" v-if="property.elements.vermarktungsart == 'miete' && (postData.delete.removal_reason != null && postData.delete.removal_reason != 'other')">
                                          <div class="input group relative flex flex-col gap-[10px]">
                                             <label for="addPrice"
                                                class="w-full text-body-medium-button">
                                                <div class="label flex flex-col gap-[10px]">
                                                   <div class="flex items-center gap-3">
                                                      <v-icon icon="euro" size="4"></v-icon>
                                                      <span>
                                                         Kakšna je končna mesečna najemnina za
                                                         nepremičnino?
                                                      </span>
                                                   </div>
                                                </div>
                                             </label>
                                             <input
                                                v-model="postData.delete.final_price"
                                                id="addPrice"
                                                type="text"
                                                name="preis"
                                                placeholder="Mesečna najemnina"
                                            />
                                             <span
                                                class="absolute bottom-[18px] right-6 text-body-medium-button"
                                                :class="postData.delete.final_price ? 'text-black-78' : 'text-black-40'">
                                                € / mesec
                                             </span>
                                             <template v-if="this.$globalFunctions.parseApiErrors(postData.errors, 'final_price')">
                                                <div class="mb-4 w-full pt-0 text-small-text-regular text-salmon"
                                                >
                                                   {{ this.$globalFunctions.parseApiErrors(postData.errors, 'final_price') }}
                                                </div>
                                             </template>
                                          </div>
                                       </li>
                                       <li class="w-full" v-if="property.elements.vermarktungsart == 'kauf' && (postData.delete.removal_reason != null && postData.delete.removal_reason != 'other')">
                                          <div class="input group relative flex flex-col gap-[10px]">
                                             <label for="addPrice"
                                                class="w-full text-body-medium-button">
                                                <div class="label flex flex-col gap-[10px]">
                                                   <div class="flex items-center gap-3">
                                                      <v-icon icon="euro" size="4"></v-icon>
                                                      <span>
                                                         Kakšna je končna prodajna cena te nepremičnine ?
                                                      </span>
                                                   </div>
                                                </div>
                                             </label>
                                             <input
                                                v-model="postData.delete.final_price"
                                                id="addPrice"
                                                type="text"
                                                name="preis"
                                                placeholder="Prodajna cena"
                                            />
                                             <span
                                                class="absolute bottom-[18px] right-6 text-body-medium-button"
                                                :class="postData.delete.final_price ? 'text-black-78' : 'text-black-40'">
                                                €
                                             </span>
                                             <template v-if="this.$globalFunctions.parseApiErrors(postData.errors, 'final_price')">
                                                <div class="mb-4 w-full pt-0 text-small-text-regular text-salmon"
                                                >
                                                   {{ this.$globalFunctions.parseApiErrors(postData.errors, 'final_price') }}
                                                </div>
                                             </template>
                                          </div>
                                       </li>
                                    </ul>
                                </div>
                              </figure>
                              <template v-if="postData.apiError">
                                <v-alert variant="error">
                                        Prišlo je do napake pri procesiranju podatkov, prosimo obrnite se na skrbnika strani.
                                </v-alert>
                                </template>
                           </template>
                           <template v-if="steps.delete.third">
                              <figure
                                 class="mx-auto my-11 flex max-w-md items-center justify-center gap-2 md:my-32">
                                 <div class="text-green">
                                    <v-icon icon="pause"></v-icon>
                                 </div>
                                 <div class="text-icon-text-medium text-green">
                                    Uspešno ste izbrisali oglas
                                 </div>
                              </figure>
                           </template>
                        </template>
                        <template v-slot:foot>
                           <template v-if="steps.delete.first">
                              <a class="button button--form button--salmon" @click="steps.delete.first = false, steps.delete.second = true, steps.delete.third = false">
                                 <label>Nadaljujte</label>
                                 <v-icon icon="arrow-right"></v-icon>
                              </a>
                           </template>
                           <template v-if="steps.delete.second">
                              <a class="button button--form button--salmon" @click="submitListingRemovalRequest()">
                                 <label>Želim izbrisati oglas</label>
                                 <v-icon icon="trash"></v-icon>
                              </a>
                           </template>
                           <template v-if="steps.delete.third">
                              <a class="button button--form" @click="steps.delete.first = true, steps.delete.second = false, steps.delete.third = false, showListingRemovalModal = false">
                                 <label>Zapri</label>
                                 <v-icon icon="close"></v-icon>
                              </a>
                           </template>
                        </template>
                     </v-lightbox>
                  </div>
               </section>
               <hr class="my-8">
               <section class="flex flex-col justify-between gap-y-6 md:flex-row" v-if="todo">
                  <div class="flex flex-1 flex-col gap-3">
                     <div class="flex items-center gap-2 text-black-40">
                        <v-icon icon="fire" class="h-[18px] w-[18px]"></v-icon>
                        <p class="text-body-regular">Oglas ni izpostavljen kot “top oglas”
                        </p>
                     </div>
                     <div
                        class="relative flex h-[6px] w-full max-w-[400px] overflow-hidden rounded-full bg-gray-border">
                        <div class="h-[6px] w-full bg-gray-border"></div>
                     </div>
                  </div>
                  <a class="button button--white button--disabled">
                     <v-icon icon="fire"></v-icon>
                     <label>Izpostavite oglas</label>
                  </a>
               </section>
               <hr class="my-8" v-if="todo">
               <section>
                  <p class="mb-4 text-body-regular text-black-40">
                     Oglas trenutno ni viden iskalcem portala, vendar je shranjen v naši bazi.
                  </p>
                  <p class="text-body-regular text-black-40">
                     Za javno objavo na portalu N24 je potrebno oglas aktivirati. To storite z zakupom
                     novega aktivnega obdobja (30, 60 ali 90 dni), tako da kliknete na gumb
                     “aktivirajte oglas”.
                  </p>
               </section>
            </div>

            <div class="w-full md:rounded-3xl md:p-11 md:shadow" v-if="inProgressPayment != null">
               <section class="flex flex-col justify-between gap-y-6 md:flex-row">
                  <div class="flex flex-1 flex-col gap-3">
                     <div class="flex items-center gap-2 text-black-78">
                        <v-icon icon="payments" class="h-[18px] w-[18px]"></v-icon>
                        <label class="text-icon-text-medium">Plačilo je v teku</label>
                     </div>
                     <div
                        class="relative flex h-[6px] w-full max-w-[400px] overflow-hidden rounded-full bg-gray-border">
                        <div class="h-[6px] w-full bg-gray-border"></div>
                     </div>
                  </div>
                  <div class="flex flex-col items-center gap-x-[10px] gap-y-6 md:flex-row">
                    <form :action="urls.cancelPaymentUrl" method="post">
                        <v-csrf-token/>
                        <button class="button button--salmon" type="submit">
                            <v-icon icon="x-circle"></v-icon>
                            <label>Prekliči plačilo</label>
                        </button>
                    </form>
                  </div>
               </section>
               <hr class="my-8">
               <section>
                  <p class="mb-4 text-body-regular text-black-40">
                     Pričeli ste s postopkom plačila oglasa.
                  </p>
                  <p class="text-body-regular text-black-40">
                     Dokler je oglas v postopku plačila, ga ni mogoče urejati, niti pričeti z novim plačilom.
                     V kolikor hočete spremeniti trajanje oglasa, prekličite obstoječe plačilo in začnite znova z gumbom Objavi oglas.
                  </p>
               </section>
            </div>

            <!-- Listing rejected-->
            <div class="w-full md:rounded-3xl md:p-11 md:shadow" v-if="inProgressPayment == null && property.elements.status == '2' && property.elements.status2 == 'ind_Schl_3269'">
               <section class="flex flex-col justify-between gap-y-6 md:flex-row">
                  <div class="flex flex-1 flex-col gap-3">
                     <div class="flex items-center gap-2 text-black-78">
                        <v-icon icon="clock" class="h-[18px] w-[18px]"></v-icon>
                        <label class="text-icon-text-medium">Oglas je zavrnjen</label>
                     </div>
                     <div
                        class="relative flex h-[6px] w-full max-w-[400px] overflow-hidden rounded-full bg-gray-border">
                        <div class="h-[6px] w-full bg-gray-border"></div>
                     </div>
                  </div>
                  <div class="flex flex-col items-center gap-x-[10px] gap-y-6 md:flex-row">
                     <a class="button" :href="urls.editProperty">
                        <v-icon icon="edit"></v-icon>
                        <label>Popravite oglas</label>
                     </a>
                  </div>
               </section>
               <hr class="my-8" v-if="todo">
               <section class="flex flex-col justify-between gap-y-6 md:flex-row" v-if="todo">
                  <div class="flex flex-1 flex-col gap-3">
                     <div class="flex items-center gap-2 text-black-40">
                        <v-icon icon="fire" class="h-[18px] w-[18px]"></v-icon>
                        <p class="text-body-regular">Oglas ni izpostavljen kot “top oglas”
                        </p>
                     </div>
                     <div
                        class="relative flex h-[6px] w-full max-w-[400px] overflow-hidden rounded-full bg-gray-border">
                        <div class="h-[6px] w-full bg-gray-border"></div>
                     </div>
                  </div>
                  <a class="button button--white button--disabled">
                     <v-icon icon="fire"></v-icon>
                     <label>Izpostavite oglas</label>
                  </a>
               </section>
               <hr class="my-8" v-if="todo">
               <section v-if="property.elements.ind_2158_Feld_ObjIndividualCategoryFields92">
                  <p class="mb-4 text-body-regular text-black-40" >
                     Za ta oglas ste zakupili paket trajanja za 90 dni. Ta oglas vam bo potekel dne {{ this.$globalFunctions.formatDate(property.elements.ind_2162_Feld_ObjIndividualCategoryFields94) }}
                  </p>
                  <p class="text-body-regular text-black-40">
                     Po poteku 90 dni se bo oglas deaktiviral. To pomeni, da bo oglas še vedno ostal v
                     naši bazi, vendar ne bo viden iskalcem. Oglas lahko ponovno aktivirate z zakupom
                     novega aktivnega obdobja (30, 60 ali 90 dni).
                  </p>
               </section>
            </div>
         </figure>

         <!-- Listing is in a non active state -->
         <figure class="flex flex-col gap-4" v-if="property.elements.status != '1'">
            <div class="text-heading-3-desktop text-black-78">Pregled povpraševanja</div>
            <div class="flex w-full items-center justify-center rounded-3xl p-11 shadow md:min-h-[540px]">
               <template v-if="property.elements.status2 == 'vorbereitung'">
                    <section class="flex h-full max-w-[358px] flex-col items-center justify-center">
                    <v-icon icon="lock" class="h-10 w-10"></v-icon>
                    <div class="mb-[14px] mt-[10px] text-center text-heading-1-mobile text-black-78">
                        Oglas je v pregledu
                    </div>
                    <div class="text-center text-body-regular text-black-40">
                        Te informacije bodo vidne, ko bo oglas odobren in objavljen.
                    </div>
                </section>
               </template>
               <template v-if="property.elements.status2 == 'ind_Schl_3269'">
                    <section class="flex h-full max-w-[358px] flex-col items-center justify-center">
                        <v-icon icon="lock" class="h-10 w-10"></v-icon>
                        <div class="mb-[14px] mt-[10px] text-center text-heading-1-mobile text-black-78">
                            Oglas je zavrnjen
                        </div>
                        <div class="text-center text-body-regular text-black-40">
                            Te informacije bodo vidne, ko bo oglas odobren in objavljen.
                        </div>
                        <a class="button mt-6">
                            <v-icon icon="preview"></v-icon>
                            <label>Popravite oglas</label>
                        </a>
                    </section>
               </template>
               <template v-if="property.elements.status2 == 'status2obj_inaktiv'">
                    <section class="flex h-full max-w-[358px] flex-col items-center justify-center">
                        <v-icon icon="lock" class="h-10 w-10"></v-icon>
                        <div class="mb-[14px] mt-[10px] text-center text-heading-1-mobile text-black-78">
                            Oglas je deaktiviran
                        </div>
                        <div class="text-center text-body-regular text-black-40">
                            Za dostop do teh podatkov mora biti oglas javno objavljen. To lahko storite z nakupom novega paketa trajanja oglasa
                        </div>
                        <a class="button mt-6" :href="urls.activateProperty" v-if="inProgressPayment == null">
                            <v-icon icon="play"></v-icon>
                            <label>Objavite oglas</label>
                        </a>
                    </section>
               </template>
            </div>
         </figure>

         <figure class="flex flex-col gap-4" v-if="property.elements.status != '1'">
            <div class="text-heading-3-desktop text-black-78">Informacije o ceni in lokaciji</div>
            <div class="flex w-full items-center justify-center rounded-3xl p-11 shadow md:min-h-[320px]">
                <template v-if="property.elements.status2 == 'vorbereitung'">
                    <section class="flex h-full max-w-[358px] flex-col items-center justify-center">
                    <v-icon icon="lock" class="h-10 w-10"></v-icon>
                    <div class="mb-[14px] mt-[10px] text-center text-heading-1-mobile text-black-78">
                        Oglas je v pregledu
                    </div>
                    <div class="text-center text-body-regular text-black-40">
                        Te informacije bodo vidne, ko bo oglas odobren in objavljen.
                    </div>
                </section>
               </template>
               <template v-if="property.elements.status2 == 'ind_Schl_3269'">
                    <section class="flex h-full max-w-[358px] flex-col items-center justify-center">
                        <v-icon icon="lock" class="h-10 w-10"></v-icon>
                        <div class="mb-[14px] mt-[10px] text-center text-heading-1-mobile text-black-78">
                            Oglas je zavrnjen
                        </div>
                        <div class="text-center text-body-regular text-black-40">
                            Te informacije bodo vidne, ko bo oglas odobren in objavljen.
                        </div>
                        <a class="button mt-6">
                            <v-icon icon="preview"></v-icon>
                            <label>Popravite oglas</label>
                        </a>
                    </section>
               </template>
               <template v-if="property.elements.status2 == 'status2obj_inaktiv'">
                    <section class="flex h-full max-w-[358px] flex-col items-center justify-center">
                        <v-icon icon="lock" class="h-10 w-10"></v-icon>
                        <div class="mb-[14px] mt-[10px] text-center text-heading-1-mobile text-black-78">
                            Oglas je deaktiviran
                        </div>
                        <div class="text-center text-body-regular text-black-40">
                            Za dostop do teh podatkov mora biti oglas javno objavljen. To lahko storite z nakupom novega paketa trajanja oglasa
                        </div>
                        <a class="button mt-6" :href="urls.activateProperty" v-if="inProgressPayment == null">
                            <v-icon icon="play"></v-icon>
                            <label>Objavite oglas</label>
                        </a>
                    </section>
               </template>
            </div>
         </figure>

         <figure class="flex flex-col gap-4" v-if="property.elements.status != '1'">
            <div class="text-heading-3-desktop text-black-78">Zgodovina cen nepremičnin</div>
            <div class="flex w-full items-center justify-center rounded-3xl p-11 shadow md:min-h-[320px]">
                <template v-if="property.elements.status2 == 'vorbereitung'">
                    <section class="flex h-full max-w-[358px] flex-col items-center justify-center">
                    <v-icon icon="lock" class="h-10 w-10"></v-icon>
                    <div class="mb-[14px] mt-[10px] text-center text-heading-1-mobile text-black-78">
                        Oglas je v pregledu
                    </div>
                    <div class="text-center text-body-regular text-black-40">
                        Te informacije bodo vidne, ko bo oglas odobren in objavljen.
                    </div>
                </section>
               </template>
               <template v-if="property.elements.status2 == 'ind_Schl_3269'">
                    <section class="flex h-full max-w-[358px] flex-col items-center justify-center">
                        <v-icon icon="lock" class="h-10 w-10"></v-icon>
                        <div class="mb-[14px] mt-[10px] text-center text-heading-1-mobile text-black-78">
                            Oglas je zavrnjen
                        </div>
                        <div class="text-center text-body-regular text-black-40">
                            Te informacije bodo vidne, ko bo oglas odobren in objavljen.
                        </div>
                        <a class="button mt-6">
                            <v-icon icon="preview"></v-icon>
                            <label>Popravite oglas</label>
                        </a>
                    </section>
               </template>
               <template v-if="property.elements.status2 == 'status2obj_inaktiv'">
                    <section class="flex h-full max-w-[358px] flex-col items-center justify-center">
                        <v-icon icon="lock" class="h-10 w-10"></v-icon>
                        <div class="mb-[14px] mt-[10px] text-center text-heading-1-mobile text-black-78">
                            Oglas je deaktiviran
                        </div>
                        <div class="text-center text-body-regular text-black-40">
                            Za dostop do teh podatkov mora biti oglas javno objavljen. To lahko storite z nakupom novega paketa trajanja oglasa
                        </div>
                        <a class="button mt-6" :href="urls.activateProperty" v-if="inProgressPayment == null">
                            <v-icon icon="play"></v-icon>
                            <label>Objavite oglas</label>
                        </a>
                    </section>
               </template>
            </div>
         </figure>

         <!-- Listing is active show arvio data -->
         <figure class="flex flex-col gap-4" v-if="property.elements.status == '1'">
            <div class="text-heading-3-desktop text-black-78">Pregled povpraševanja</div>
            <div class="w-full items-center justify-center rounded-3xl p-11 shadow md:min-h-[540px]">
               <p class="text-body-regular text-black-40">
                  Vašo nepremičnino je povprašalo <strong>{{ interestedCustomers.length }} iskalcev</strong>.
               </p>
               <div
                  v-for="(interestedCustomer, index) in interestedCustomers"
                  v-bind:key="'matching-search-criteria' + index"
                  class="flex"
               >
               <article class="flex w-full flex-row-reverse gap-6 max-lg:items-center max-lg:justify-between lg:flex-col">
                    <div class="flex flex-1 flex-col gap-2 lg:flex-row">
                        <a class="flex min-h-[38px] flex-1 cursor-pointer touch-manipulation select-none items-center justify-start gap-2 rounded-full bg-green-10 px-4 text-small-text-medium text-black-78 disabled:bg-gray-E5 disabled:text-black-78 md:py-2 md:text-small-text-medium lg:my-2 lg:min-h-fit lg:bg-white lg:text-body-medium-button">
                            <v-icon icon="user" class="h-[14px] w-[14px]"></v-icon>
                            <label>
                                {{ interestedCustomer.elements.Name }} {{ interestedCustomer.elements.Vorname }}
                            </label>
                        </a>
                        <span class="flex justify-end min-h-[38px] flex-1 cursor-pointer touch-manipulation select-none items-center justify-start gap-2 rounded-full bg-green-10 px-4 text-small-text-medium text-black-78 disabled:bg-gray-E5 disabled:text-black-78 md:py-2 md:text-small-text-medium lg:my-2 lg:min-h-fit lg:bg-white lg:text-body-medium-button">
                            <v-lightbox
                                :head-class="'border-b'"
                                :content-class="'px-4 md:px-8'"
                                :foot-class="'justify-center border-t'"
                                :is-authenticated="true"
                            >
                                <template v-slot:trigger>
                                    <a class="button">
                                        <v-icon icon="hand-wave"></v-icon>
                                        <label>Stopite v stik</label>
                                    </a>
                                </template>
                                <template v-slot:head>
                                <v-icon icon="hand-wave" size="4" class="mr-2.5"></v-icon>
                                <label>Stopite v stik</label>
                                </template>
                                <template v-slot:content>
                                    <figure
                                        class="mb-8 flex max-w-xs items-center gap-4 md:mx-auto"
                                    >
                                        <div class="relative">
                                            <div
                                                class="flex h-[72px] w-[72px] items-center justify-center overflow-hidden rounded-full bg-gray-border"
                                            >
                                                <img
                                                    v-if="interestedCustomer.elements.imageUrl"
                                                    class="min-h-full min-w-full max-w-full rounded-full object-cover"
                                                    :src="interestedCustomer.elements.imageUrl"
                                                    alt=""
                                                />
                                                <img
                                                    v-else
                                                    class="min-h-full min-w-full max-w-full rounded-full object-cover"
                                                    :src="
                                                        $assetsUrl +
                                                        '/images/profile_placeholder.png'
                                                    "
                                                    alt=""
                                                />
                                            </div>
                                            <div
                                                class="absolute bottom-0 right-0 flex h-6 w-6 items-center justify-center rounded-full bg-green"
                                            >
                                                <v-icon
                                                    icon="certificate"
                                                    class="text-white"
                                                    size="3.5"
                                                ></v-icon>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="text-heading-3-desktop text-black-78">
                                                {{
                                                    interestedCustomer.elements.Vorname +
                                                    " " +
                                                    interestedCustomer.elements.Name
                                                }}
                                            </div>
                                            <div
                                                class="mt-1 text-small-text-regular text-black-40"
                                            >
                                                Preverjena fizična oseba
                                            </div>
                                        </div>
                                    </figure>
                                    <figure class="mb-8 flex max-w-xs flex-col gap-6 md:mx-auto">
                                        <section class="flex gap-[10px]">
                                            <v-icon icon="contact-emergency"></v-icon>
                                            <div>
                                                <div class="mb-2 text-body-bold text-black-78">
                                                    Kontaktni podatki
                                                </div>
                                                <div class="mb-2 flex gap-2 text-small-text-medium text-black-40">
                                                    <v-icon icon="call"></v-icon>
                                                    <div>{{ interestedCustomer.elements.Telefon1 }}</div>
                                                </div>
                                                <div class="flex gap-2 text-small-text-medium text-black-40">
                                                    <v-icon icon="outgoing-mail"></v-icon>
                                                    <div>{{ interestedCustomer.elements.Email }}</div>
                                                </div>
                                            </div>
                                        </section>
                                    </figure>
                                </template>
                                <template v-slot:foot>

                                </template>
                            </v-lightbox>
                        </span>
                    </div>
                </article>
                <hr class="my-4">
               </div>

            </div>
         </figure>

         <template v-if="property.elements.status == '1' && arvio && property.elements.objektart">
            <v-listing-price-information
               :min-price="arvio.min"
               :max-price="arvio.max"
               :per-square-meter-price="arvio.price"
               :property="this.$globalFunctions.onOfficeValueResolver(onOfficeLabels, 'objektart', property.elements.objektart)"
               :with-header="true"
            ></v-listing-price-information>
         </template>

         <template v-if="property.elements.status == '1'">
            <v-listing-price-history
               :region-name="arvioMapping.arvio_region">
            </v-listing-price-history>
         </template>

      </section>
   </main>
</template>

<script>

export default {
    props: {
        property: {
            type: Object,
            required: true,
        },
        session: {
            type: Object,
            required: false,
            default: {}
        },
        urls: {
            type: Object,
            required: true,
        },
        locations: {
            type: Object,
            required: true,
        },
        headerSetupData: {
            type: Object,
            required: true,
        },
        onOfficeLabels: {
            type: Object,
            required: true,
        },
        arvioMapping: {
            type: Object,
            required: true,
        },
        arvio: {
            type: Object,
            required: false,
        },
        interestedCustomers: {
            type: Object,
            required: true,
        },
        inProgressPayment: {
            type: Object,
            required: false,
            default: null,
        },
        completedPayment: {
            type: Object,
            required: false,
            default: null,
        }
    },
    data() {
        return {
            todo: false,
            showListingRemovalModal: false,
            showListingDeactivationModal: false,
            steps: {
                delete: {
                    first: true,
                    second: false,
                    third: false,
                },
                deactivate: {
                    first: true,
                    second: false,
                    third: false,
                }
            },
            postData: {
                delete: {
                    removal_reason: null,
                    final_price: null,
                    on_office_id: this.property.id,
                    transaction_type: this.property.elements.vermarktungsart,
                },
                deactivate: {
                    disable_reason: null,
                    final_price: null,
                    on_office_id: this.property.id,
                    transaction_type: this.property.elements.vermarktungsart,
                },
                errors: {},
                apiError: false,
            },

            stepFirst: true,
            stepSecond: false,
            stepThird: false,
        };
    },
    methods: {
        submitListingRemovalRequest() {
            let headers = {
               headers: {
                  "X-CSRF-TOKEN": this.$csrfToken,
               },
            }

            axios.post(this.urls.deleteProperty, this.postData.delete, headers)
                .then((response) => {
                    this.steps.delete.first = false;
                    this.steps.delete.second = false;
                    this.steps.delete.third = true;
                    this.postData.errors = {};
                },(error) => {
                  console.log(error)
                  if(error.response.status == 500) {
                     this.postData.apiError = true
                  } else {
                     this.postData.errors = error.response.data.errors
                  }
            });

        },
        submitListingDeactivationRequest() {
            let headers = {
               headers: {
                  "X-CSRF-TOKEN": this.$csrfToken,
               },
            }

            axios.post(this.urls.deactivateProperty, this.postData.deactivate, headers)
                .then((response) => {
                    this.steps.deactivate.first = false;
                    this.steps.deactivate.second = false;
                    this.steps.deactivate.third = true;
                    this.postData.errors = {};
                },(error) => {
                  console.log(error)
                  if(error.response.status == 500) {
                     this.postData.apiError = true
                  } else {
                     this.postData.errors = error.response.data.errors
                  }
            });

        },
    },
};
</script>
